/**
 * ============================================================================
 * 培训管理模块常量定义
 * ============================================================================
 */

import { 
  TrainingTaskStatus, 
  TrainingLevel, 
  ParticipantStatus, 
  AttendanceStatus,
  TrainingTypeCategory,
  TrainingPhotoType 
} from './enums'

/** 培训任务状态标签 */
export const TRAINING_TASK_STATUS_LABELS: Record<TrainingTaskStatus, string> = {
  [TrainingTaskStatus.DRAFT]: '草稿',
  [TrainingTaskStatus.PUBLISHED]: '已发布',
  [TrainingTaskStatus.IN_PROGRESS]: '培训中',
  [TrainingTaskStatus.COMPLETED]: '已完成',
  [TrainingTaskStatus.CANCELLED]: '已取消',
}

/** 培训等级标签 */
export const TRAINING_LEVEL_LABELS: Record<TrainingLevel, string> = {
  [TrainingLevel.COMPANY]: '公司级',
  [TrainingLevel.WORKSHOP]: '车间级',
  [TrainingLevel.TEAM]: '班组级',
}

/** 参与者状态标签 */
export const PARTICIPANT_STATUS_LABELS: Record<ParticipantStatus, string> = {
  [ParticipantStatus.PENDING]: '待确认',
  [ParticipantStatus.CONFIRMED]: '已确认',
  [ParticipantStatus.IN_PROGRESS]: '培训中',
  [ParticipantStatus.COMPLETED]: '已完成',
  [ParticipantStatus.ABSENT]: '缺席',
}

/** 到场状态标签 */
export const ATTENDANCE_STATUS_LABELS: Record<AttendanceStatus, string> = {
  [AttendanceStatus.NOT_MARKED]: '未标记',
  [AttendanceStatus.SIGN_IN_CODE]: '签到码签到',
  [AttendanceStatus.MANUAL]: '手动标记',
  [AttendanceStatus.ABSENT]: '缺席',
}

/** 培训类型分类标签（与后端 TrainingType::getCategoryLabels 一致） */
export const TRAINING_TYPE_CATEGORY_LABELS: Record<TrainingTypeCategory, string> = {
  [TrainingTypeCategory.MANDATORY]: '法定强制培训',
  [TrainingTypeCategory.CERTIFICATION]: '体系认证培训',
  [TrainingTypeCategory.CUSTOMER]: '客户特定培训',
  [TrainingTypeCategory.PROCESS]: '工艺专项培训',
  [TrainingTypeCategory.EQUIPMENT]: '设备操作培训',
  [TrainingTypeCategory.CHANGE]: '变更管理培训',
  [TrainingTypeCategory.EMERGENCY]: '应急响应培训',
  [TrainingTypeCategory.QUALITY]: '质量工具培训',
}

/** 培训照片类型标签（与后端 TrainingPhoto::getTypeLabels 一致） */
export const TRAINING_PHOTO_TYPE_LABELS: Record<TrainingPhotoType, string> = {
  [TrainingPhotoType.SCENE]: '培训现场',
  [TrainingPhotoType.SIGN_SHEET]: '签到表',
  [TrainingPhotoType.OTHER]: '其他',
}

/** 培训任务状态选项 */
export const TRAINING_TASK_STATUS_OPTIONS = Object.entries(TRAINING_TASK_STATUS_LABELS).map(
  ([value, label]) => ({ value: Number(value), label })
)

/** 培训等级选项 */
export const TRAINING_LEVEL_OPTIONS = Object.entries(TRAINING_LEVEL_LABELS).map(
  ([value, label]) => ({ value: Number(value), label })
)

/** 培训类型分类选项 */
export const TRAINING_TYPE_CATEGORY_OPTIONS = Object.entries(TRAINING_TYPE_CATEGORY_LABELS).map(
  ([value, label]) => ({ value, label })
)
